/**
 * Preorder-aware delivery date for the PDP daily cutoff timer.
 * Uses product/variant data and STOQ markup on the page — not the cart.
 */
(function () {
  'use strict';

  var SHIP_DATE_RE = /ships\s+on\s+([A-Za-z]+)\s+(\d{1,2}),?\s*(\d{4})/gi;
  var MONTHS = {
    jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5,
    jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11
  };

  var variantDatesCache = null;

  function parseShipDate(value) {
    SHIP_DATE_RE.lastIndex = 0;
    var m = SHIP_DATE_RE.exec(String(value || ''));
    if (!m) return null;
    var mo = MONTHS[m[1].slice(0, 3).toLowerCase()];
    if (mo === undefined) return null;
    var d = parseInt(m[2], 10);
    var y = parseInt(m[3], 10);
    if (isNaN(d) || isNaN(y)) return null;
    return new Date(y, mo, d);
  }

  function parseAllShipDates(text) {
    var latest = null;
    var str = String(text || '');
    var re = /ships\s+on\s+([A-Za-z]+)\s+(\d{1,2}),?\s*(\d{4})/gi;
    var m;
    while ((m = re.exec(str)) !== null) {
      var mo = MONTHS[m[1].slice(0, 3).toLowerCase()];
      if (mo === undefined) continue;
      var d = parseInt(m[2], 10);
      var y = parseInt(m[3], 10);
      if (isNaN(d) || isNaN(y)) continue;
      var date = new Date(y, mo, d);
      if (!latest || date > latest) latest = date;
    }
    return latest;
  }

  function getVariantDatesMap() {
    if (variantDatesCache) return variantDatesCache;
    var el = document.querySelector('.js-delivery-variant-preorder-dates');
    if (!el) return {};
    try {
      variantDatesCache = JSON.parse(el.textContent);
      return variantDatesCache;
    } catch (e) {
      return {};
    }
  }

  function getSelectedVariantId(container) {
    var fromData = container.getAttribute('data-current-variant-id');
    if (fromData) return fromData;

    var section = container.closest('.js-product, .product-main');
    if (!section) return null;

    var picker = section.querySelector('variant-picker');
    if (picker && picker.variant && picker.variant.id) {
      return String(picker.variant.id);
    }

    var input = section.querySelector('[name="id"]');
    if (input && input.value) return input.value;

    return null;
  }

  function getShipDateFromVariantMap(variantId) {
    if (!variantId) return null;
    var map = getVariantDatesMap();
    var entry = map[String(variantId)];
    if (!entry || !entry.nextIncomingDate) return null;
    var parts = entry.nextIncomingDate.split('-');
    if (parts.length !== 3) return null;
    return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
  }

  function getShipDateFromProductForm() {
    var section = document.querySelector('.js-product, .product-main');
    var form = section
      ? section.querySelector('.js-product-form-main, .js-product-form')
      : document.querySelector('.js-product-form-main, .js-product-form');
    if (!form) return null;

    var latest = null;
    var inputs = form.querySelectorAll('[name^="properties["], [data-stoq-preorder], [data-preorder-date]');
    for (var i = 0; i < inputs.length; i++) {
      var el = inputs[i];
      var candidates = [el.value, el.getAttribute('value'), el.textContent, el.getAttribute('data-preorder-date')];
      for (var c = 0; c < candidates.length; c++) {
        var date = parseShipDate(candidates[c]);
        if (date && (!latest || date > latest)) latest = date;
      }
    }
    return latest;
  }

  function scanProductPageForShipDate(container) {
    var section = container.closest('.js-product, .product-main, .cc-main-product');
    if (!section) return null;

    var clone = section.cloneNode(true);
    clone.querySelectorAll('.delivery-message-container').forEach(function (el) {
      el.remove();
    });

    return parseAllShipDates(clone.textContent);
  }

  function resolvePreorderShipDate(container) {
    var liquidShipIso = container.getAttribute('data-preorder-ship-iso') || '';
    var preorderShip = null;

    if (liquidShipIso) {
      var parts = liquidShipIso.split('-');
      if (parts.length === 3) {
        preorderShip = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      }
    }

    var variantId = getSelectedVariantId(container);
    if (variantId) {
      container.setAttribute('data-current-variant-id', variantId);
    }

    var variantDate = getShipDateFromVariantMap(variantId);
    if (variantDate && (!preorderShip || variantDate > preorderShip)) preorderShip = variantDate;

    var formDate = getShipDateFromProductForm();
    if (formDate && (!preorderShip || formDate > preorderShip)) preorderShip = formDate;

    var domDate = scanProductPageForShipDate(container);
    if (domDate && (!preorderShip || domDate > preorderShip)) preorderShip = domDate;

    return preorderShip;
  }

  function startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  function formatYmd(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function ordinalSuffix(day) {
    if (day % 10 === 1 && day !== 11) return 'st';
    if (day % 10 === 2 && day !== 12) return 'nd';
    if (day % 10 === 3 && day !== 13) return 'rd';
    return 'th';
  }

  function formatDeliveryLabel(date) {
    var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var d = date.getDate();
    return {
      weekday: days[date.getDay()],
      formatted: d + ordinalSuffix(d) + ' ' + months[date.getMonth()]
    };
  }

  function parseCutoffMinutes(cutoffTime) {
    var parts = String(cutoffTime || '17:00').split(':');
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
  }

  function parseServerMinutes(serverTime) {
    var parts = String(serverTime || '').split(':');
    if (parts.length < 2) return null;
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
  }

  function getNormalDispatchDate(serverMinutes, cutoffMinutes, baseDate) {
    var base = startOfDay(baseDate || new Date());
    if (serverMinutes == null) {
      var now = new Date();
      serverMinutes = now.getHours() * 60 + now.getMinutes();
    }
    if (serverMinutes >= cutoffMinutes) {
      base.setDate(base.getDate() + 1);
    }
    return base;
  }

  function findDispatchAndDelivery(dispatchStart, holidays) {
    var dispatch = startOfDay(dispatchStart);
    for (var attempt = 0; attempt < 21; attempt++) {
      var dispatchStr = formatYmd(dispatch);
      if (holidays.indexOf(dispatchStr) !== -1) {
        dispatch.setDate(dispatch.getDate() + 1);
        continue;
      }
      var delivery = new Date(dispatch.getTime());
      delivery.setDate(delivery.getDate() + 1);
      var deliveryStr = formatYmd(delivery);
      if (holidays.indexOf(deliveryStr) !== -1) {
        dispatch.setDate(dispatch.getDate() + 1);
        continue;
      }
      return { dispatch: dispatch, delivery: delivery };
    }
    var fallbackDelivery = new Date(dispatch.getTime());
    fallbackDelivery.setDate(fallbackDelivery.getDate() + 1);
    return { dispatch: dispatch, delivery: fallbackDelivery };
  }

  function isDeliveryTomorrow(delivery, today) {
    var tomorrow = new Date(today.getTime());
    tomorrow.setDate(tomorrow.getDate() + 1);
    return formatYmd(delivery) === formatYmd(tomorrow);
  }

  function buildMessage(isBeforeCutoff, isTomorrow, deliveryLabel) {
    if (isBeforeCutoff && isTomorrow) {
      return 'for earliest delivery tomorrow &ldquo;<b>' + deliveryLabel.weekday + '</b>&rdquo;.';
    }
    return 'for earliest delivery by &ldquo;<b>' + deliveryLabel.weekday + '</b>&rdquo;, ' + deliveryLabel.formatted + '.';
  }

  function updateContainer(container) {
    var holidaysRaw = container.getAttribute('data-holidays') || '';
    var holidays = holidaysRaw.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
    var cutoffTime = container.getAttribute('data-cutoff-time') || '17:00';
    var serverTime = container.getAttribute('data-server-time') || '';
    var isBeforeCutoff = container.getAttribute('data-before-cutoff') === 'true';

    var cutoffMinutes = parseCutoffMinutes(cutoffTime);
    var serverMinutes = parseServerMinutes(serverTime);
    var today = startOfDay(new Date());
    var normalDispatch = getNormalDispatchDate(serverMinutes, cutoffMinutes, today);

    var preorderShip = resolvePreorderShipDate(container);
    var usePreorder = container.getAttribute('data-use-preorder') === 'true' || !!preorderShip;

    if (preorderShip) {
      container.setAttribute('data-preorder-ship-iso', formatYmd(preorderShip));
      container.setAttribute('data-use-preorder', 'true');
    }

    var dispatchStart = normalDispatch;
    if (usePreorder && preorderShip) {
      var shipDay = startOfDay(preorderShip);
      if (shipDay.getTime() >= today.getTime() && shipDay.getTime() > normalDispatch.getTime()) {
        dispatchStart = shipDay;
      }
    }

    var schedule = findDispatchAndDelivery(dispatchStart, holidays);
    var deliveryLabel = formatDeliveryLabel(schedule.delivery);
    var isTomorrow = isBeforeCutoff && isDeliveryTomorrow(schedule.delivery, today);
    var suffix = buildMessage(isBeforeCutoff, isTomorrow, deliveryLabel);

    var messageEl = container.querySelector('.delivery-message-text');
    if (messageEl) {
      messageEl.innerHTML = suffix;
    }
  }

  function refreshAll() {
    document.querySelectorAll('.delivery-message-container[data-product-id]').forEach(updateContainer);
  }

  function observeProductSection() {
    var section = document.querySelector('.js-product, .product-main');
    if (!section || !window.MutationObserver) return;

    var debounce;
    var observer = new MutationObserver(function () {
      clearTimeout(debounce);
      debounce = setTimeout(refreshAll, 150);
    });

    observer.observe(section, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['value']
    });
  }

  function init() {
    refreshAll();
    observeProductSection();
    [400, 1200, 2500, 5000].forEach(function (ms) {
      setTimeout(refreshAll, ms);
    });
  }

  document.addEventListener('DOMContentLoaded', init);

  document.addEventListener('on:variant:change', function (evt) {
    if (!evt.detail || !evt.detail.variant) return;
    document.querySelectorAll('.delivery-message-container[data-product-id]').forEach(function (container) {
      container.setAttribute('data-current-variant-id', String(evt.detail.variant.id));
    });
    setTimeout(refreshAll, 50);
  });

  window.refreshDeliveryDateMessages = refreshAll;
})();
